import { getDataWithName, removeUndefineds, removeSlashesFromName, decorateWithTimestampsForFirestore } from './FirestoreUtils'

export default class CustomerService {
  constructor (orgRef) {
    this.customers = orgRef.collection(`customers`)
  }

  async getCustomer (name) {
    let doc = await this.customers.doc(name).get()
    return getDataWithName(doc)
  }

  async getCustomers () {
    let querySnapshot = await this.customers.get()
    let customers = {}
    querySnapshot.forEach(doc => { customers[doc.id] = getDataWithName(doc) })
    return customers
  }

  async addCustomer (customer) {
    customer.name = removeSlashesFromName(customer.name)
    removeUndefineds(customer)
    decorateWithTimestampsForFirestore(customer)
    let customerToSave = Object.assign({}, customer)
    delete customerToSave.name
    await this.customers.doc(customer.name).set(customerToSave, { merge: true })
    return customer
  }

  async deleteCustomer (name) {
    return this.customers.doc(name).delete()
  }
}
